<template>
    <div>
        <b-row>
            <b-col sm="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">Documentos</span>
                    </b-card-header>
                    <b-card-body>
                        <app-tabela
                            idTabela="tblAnexos"
                            :itens="anexos"
                            :campos="campos"
                            :itensPorPagina="itensPorPagina"
                            :bordered="false"
                            :small="false"
                        >
                            <template slot="botoes">
                                <b-button-group class="float-right">
                                    <b-button
                                        class="mr-2"
                                        variant="primary"
                                        @click.stop="inserirAnexo()"
                                        v-if="mostrarBtnInserirDocumento"
                                    >
                                        <i class="fa fa-plus"></i> Inserir Documento
                                    </b-button>
                                    <b-button
                                        variant="warning"
                                        @click.stop="$emit('fecharDocumentos')"
                                    >
                                        <i class="fa fa-times-circle"></i> Fechar Documentos
                                    </b-button>
                                </b-button-group>
                                <slot name="botoes"></slot>
                            </template>
                            <template slot="acoes" slot-scope="data">
                                <pagamento-documento-download
                                    :pagamentoAnexo="data"
                                    :pagamentosServicos="pagamentosServicos"
                                ></pagamento-documento-download>
                                <pagamento-documento-excluir
                                    :pagamento="pagamento"
                                    :pagamentoAnexo="data"
                                    :pagamentosServicos="pagamentosServicos"
                                    @obterPagamentoAtualizado="
                                        obterDocumentos()
                                    "
                                    class="ml-1"
                                    v-if="mostrarBtnExcluirAnexo"
                                ></pagamento-documento-excluir>
                            </template>
                        </app-tabela>
                    </b-card-body>
                </b-card>
            </b-col>
        </b-row>
        <pagamento-documento-form
            ref="pagamentoAnexoForm"
            @obterDocumentos="obterDocumentos()"
            :pagamento="pagamento"
            :pagamentosServicos="pagamentosServicos"
        ></pagamento-documento-form>
    </div>
</template>

<script>
import PagamentoDocumentoDownload from './PagamentoDocumentoDownload'
import PagamentoDocumentoForm from './PagamentoDocumentoForm'
import PagamentoDocumentoExcluir from './PagamentoDocumentoExcluir'
import { pagamentoStatus } from './PagamentoStatus'

export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {
            campos: [
                {
                    key: 'acoes',
                    label: 'Ações'
                },
                {
                    key: 'anexoTipoDescricao',
                    label: 'Tipo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Descritivo',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'nomeArquivoOriginal',
                    label: 'Arquivo'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                }
            ],
            itensPorPagina: 0,
            anexos: []
        }
    },

    methods: {
        inserirAnexo() {
            this.$refs.pagamentoAnexoForm.mostrarModal = true
        },

        obterPagamentoAtualizado() {
            this.$emit('obterPagamentoAtualizado')
        },

        obterDocumentos() {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .obterDocumentos(this.$route.params.pagamentoId)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.anexos = response.data
                        } else {
                            this.$toast.error(
                                'Não foi possível obter os documentos.',
                                'ERROR',
                                this.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        },
    },

    computed: {
        mostrarBtnInserirDocumento() {
            return (this.$temAcesso('DESP-GERAIS-PAG-DOC-01'))
        },

        mostrarBtnExcluirAnexo() {
            return (this.$temAcesso('DESP-GERAIS-PAG-DOC-02'))
        }
    },

    created() {
        this.obterDocumentos()
    },

    components: {
        PagamentoDocumentoForm,
        PagamentoDocumentoDownload,
        PagamentoDocumentoExcluir
    }
}
</script>
